var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "svg13",
    viewBox: "0 0 10 6",
    height: "6px",
    width: "10px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "icon/navigation/unfold_more_24px@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7 9.5 12 14.5 17 9.5",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,6)",
    fillRule: "evenodd",
    fill: "none",
    strokeWidth: 1,
    stroke: "none",
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7,-9)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    y: 0,
    x: 0,
    id: "use7",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    y: 0,
    x: 0,
    xlinkHref: "#path-1",
    fill: "#000000",
    id: "icon/navigation/arrow_drop_down_24px"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold);
export default __webpack_public_path__ + "static/media/Fold.d840e402475a39e49f2d8d2d1033dd4b.svg";
export { ForwardRef as ReactComponent };